import SimpleLightbox from 'simplelightbox'

class Lightbox {
  /**
   * Contructor
   *
   * @param {Element} el The Lightbox container element
   */
  constructor(el) {
    this.container = el
    this.images = this.container.querySelectorAll('img')

    if (this.images) {
      this.lightbox = new SimpleLightbox(this.images, {
        sourceAttr: 'src',
      })
    }
  }
}

const lightboxInit = {
  // eslint-disable-next-line consistent-return
  init() {
    const wrapperEl = document.querySelectorAll('.wp-block-image')
    Array.from(wrapperEl).forEach(el => new Lightbox(el))
  },
}

export default lightboxInit
